import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"

import {FormattedMessage} from "@irati/utils/lang"
import padding from "@irati/ui/src/global/padding"
import id from "@irati/utils/id"
import {Lato} from "@irati/ui/src/global/fonts"

import {IconTooltip} from "../Tooltip"

const Label = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0;
  ${Lato}
`

const StyledTooltip = styled(IconTooltip)`
  margin-left: ${padding.tiny};
`

const LabelWIthIconTooltip = ({text, tooltipText, ...props}) => {
  const idNamespace = id("Label", props)
  return (
    <Label id={idNamespace}>
      <FormattedMessage id={text} />
      {tooltipText && <StyledTooltip><FormattedMessage id={tooltipText} /></StyledTooltip>}
    </Label>
  )
}

LabelWIthIconTooltip.propTypes = {
  text: PropTypes.string.isRequired,
  tooltipText: PropTypes.string
}
LabelWIthIconTooltip.defaultProps = {
  tooltipText: null
}

export default LabelWIthIconTooltip
